import _get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export function getPageAttributes(dataLayer) {
  const {
    pg,
    brandPg,
    testName,
    experimentBoosts,
    pixallPageInstanceId
  } = _get(dataLayer, 'page', {});
  return {
    ...(testName?.length > 0 && {
      abTestId: testName
    }),
    experimental: {
      boost: experimentBoosts
    },
    label: brandPg || pg,
    pageInstanceId: pixallPageInstanceId,
    pageId: pg === 'error' ? pg : brandPg || pg,
    vehicleType: dataLayer?.vehicle?.type
  };
}
export function getPageId(dataLayer) {
  return _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
}
export function getPageName(dataLayer) {
  return _get(dataLayer, 'page.pageName', '');
}
export function getZipCode(dataLayer) {
  return _get(dataLayer, 'user.zipCode');
}
export async function getConsumerMetadata(dataLayer) {
  const consumerMetadata = typeof dataLayer?.consumerMetadata === 'function' ? await dataLayer.consumerMetadata() : {};
  const consumerMetadataCopy = cloneDeep(consumerMetadata);
  return {
    consumerMetadataCopy
  };
}
export function getCDLVehicleSearch(_temp) {
  let {
    search = {}
  } = _temp === void 0 ? {} : _temp;
  const searchCopy = cloneDeep(search);
  const {
    filters = {}
  } = searchCopy;
  const {
    keywordPhrases,
    makeCode,
    modelCode,
    vehicleHistoryType,
    sellerType,
    homeServices
  } = filters ?? {};
  return {
    searchKeywords: keywordPhrases || {
      makeCode,
      modelCode
    },
    vehicleHistory: vehicleHistoryType,
    vehicleSellerType: sellerType,
    atHomeVehicleServices: homeServices
  };
}
export const vehicleSearchTransformer = dataLayer => {
  const {
    search
  } = dataLayer;
  const searchCopy = cloneDeep(search);
  if (searchCopy) {
    const mapper = {
      d: 'dealer',
      p: 'private-seller'
    };
    const {
      filters = {}
    } = searchCopy;
    const {
      vehicleHistoryType,
      sellerType,
      homeServices,
      keywordPhrases,
      makeCode,
      modelCode
    } = filters;
    return {
      searchKeywords: keywordPhrases || {
        makeCode,
        modelCode
      },
      vehicleHistory: vehicleHistoryType,
      vehicleSellerType: sellerType?.map?.(item => mapper[item]),
      atHomeVehicleServices: homeServices
    };
  }
  return {};
};
export default {
  getPageAttributes,
  getPageId,
  getPageName,
  getZipCode,
  getConsumerMetadata,
  getCDLVehicleSearch,
  vehicleSearchTransformer
};